<template>
  <div>
    <Modal v-model="visible" width="1000px" :title="title" :footer-hide="true" :mask-closable="false"
      class="my-modal top">
      <Form ref="form" :model="formData" :label-width="100" class="page-form">
        <FormItem prop="productName" label="出险产品名称" class="full" :rules="$units.formRule.required('请输入')">
          <Input v-model="formData.productName" placeholder="请输入" :disabled="!isOutPolicy" />
        </FormItem>
        <FormItem label="保单号">
          <Input v-model="formData.policyNo" placeholder="回显" disabled />
        </FormItem>
        <FormItem label="出单机构">
          <Input v-model="formData.orgName" placeholder="回显" disabled />
        </FormItem>
        <FormItem prop="groupId" label="出单团队" :rules="$units.formRule.required('请输入')">
          <Input v-model="formData.groupName" placeholder="回显" disabled />
        </FormItem>
        <FormItem prop="salesmanId" label="业务员" :rules="$units.formRule.required('请输入')">
          <Input v-model="formData.salesmanName" placeholder="回显" disabled />
        </FormItem>
        <FormItem prop="contactName" label="联系人" :rules="$units.formRule.required('请输入')">
          <Input v-model="formData.contactName" placeholder="请输入" :disabled="!!formData.id" />
        </FormItem>
        <FormItem prop="contactMobile" label="联系人手机" :rules="formData.id?{required:false}:$units.formRule.tel()">
          <Input v-model="formData.contactMobile" placeholder="请输入" :disabled="!!formData.id" />
        </FormItem>
        <FormItem label="出险人">
          <Input v-model="formData.accidentPerson" placeholder="请输入" :disabled="!!formData.id" />
        </FormItem>
        <FormItem label="出险类型">
          <lzDicSelect v-model="formData.accidentType" dicType="ACCIDENTTYPE" :transfer="true" :disabled="!!formData.id">
          </lzDicSelect>
        </FormItem>
        <FormItem label="报案日期" prop="caseDate" :rules="$units.formRule.required('请选择')">
          <DatePicker type="date" :value="formData.caseDate" @on-change="$set(formData,'caseDate',$event)" format="yyyy-MM-dd"
            placeholder="选择日期" transfer :disabled="!!formData.id"></DatePicker>
        </FormItem>
        <FormItem label="出险描述" class="full">
          <Input v-model="formData.accidentDescribe" placeholder="请输入" type="textarea" show-word-limit
            :disabled="!!formData.id" :maxlength="200" :clearable="true" />
        </FormItem>
        <!-- 自建理赔记录 -->
        <FormItem prop="claimsState" label="理赔状态" :rules="$units.formRule.required('请选择')" v-if="formData.sourceType == 1">
          <Select v-model="formData.claimsState" filterable @on-change="formData.claimsResult = '';" transfer
            :disabled="!!formData.id">
            <Option value="0">待处理</Option>
            <Option value="2">处理中</Option>
            <Option value="1">已处理</Option>
          </Select>
        </FormItem>
        <!-- 理赔状态是已处理且是自建理赔记录 -->
        <template v-if=" formData.claimsState == 1 && formData.sourceType == 1">
          <FormItem label="理赔结果" prop="claimsResult" :rules=" $units.formRule.required('请选择') ">
            <Select v-model=" formData.claimsResult " transfer>
              <Option value="1">理赔成功</Option>
              <Option value="0">理赔失败</Option>
            </Select>
          </FormItem>
          <FormItem label="理赔结案时间" prop="claimsCaseDate" :rules=" $units.formRule.required('请选择') ">
            <DatePicker type="date" :value=" formData.claimsCaseDate "
              @on-change=" $set(formData, 'claimsCaseDate', $event); " format="yyyy-MM-dd" placeholder="选择日期" transfer>
            </DatePicker>
          </FormItem>
          <FormItem prop="claimsAmount" label="理赔金额" :rules=" $units.formRule.money(false, '请输入正确的理赔金额') ">
            <Input v-model=" formData.claimsAmount " placeholder="请输入" >
              <span slot="suffix" >元</span>
            </Input>
          </FormItem>
        </template>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click=" back ">{{formData.id?'取消':'上一步'}}</Button>
        <Button type="primary" :loading="loading" @click=" submit() ">确定</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import lzDicSelect from "@/components/commons/lzDicSelect";
export default {
  components: {
    selectTree,
    lzDicSelect
  },
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      isOutPolicy: false,//是否是外部保单
      formData: {},
      title: '',
      userList: [],//当前机构的业务员
      userInfo: {},//登录用户信息
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    back() {
      this.visible = false;
      this.$emit('back')
    },
    open(formData = {}) {
      // sourceType 1自建，2在线理赔
      if (formData.sourceType == 1) {
        this.title = formData.id ? '编辑理赔记录' : '自建理赔记录';
      } else if (formData.sourceType == 2) {
        this.title = formData.id ? '编辑在线理赔' : '申请在线理赔';
      }
      this.isOutPolicy = formData.formType == -1;//isOutPolicy是否是外部保单 formType -1非系统保单 1录入保单 2平台保单 
      const userInfo = this.userInfo;
      formData.orgName = userInfo.organizationName;
      formData.orgId = userInfo.organId;
      formData.groupName = userInfo.groupName;
      formData.groupId = userInfo.groupId;
      formData.salesmanName = userInfo.userName;
      formData.salesmanId = userInfo.userid;
      if(formData.caseDate){
        formData.caseDate = formData.caseDate.substring(0,10);
      }
      this.formData = formData;
      this.visible = true;
      this.$nextTick(() => {
        // 清除验证信息
        this.$refs.form && this.$refs.form.fields.forEach(item => {
          item.validateState = '';
          item.validateMessage = '';
        });
      })
    },
    submit() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if(formData.claimsState != 1) {
          delete formData.claimsResult;
          delete formData.claimsCaseDate;
          delete formData.claimsAmount;
        }
        if(formData.claimsCaseDate<formData.caseDate){
          this.$notice.error("理赔结案时间不能早于报案时间")
          return;
        }
        if(this.loading){
          return;
        }
        this.loading = true;
        this.$http({
          url: formData.id?'/buz/orderCompensation/edit':'/buz/orderCompensation/add',
          type: 'POST',
          data: formData,
        }).then((res) => {
          this.$emit("reload");
          this.visible = false;
        }).finally(()=>{
          window.setTimeout(()=>{
            this.loading = false;
          }, 500);
        })
      });
    }
  },


};
</script>
<style lang="scss" scoped>
/deep/ .ivu-input-suffix {
  line-height: 30px;
}
</style>